module.exports = __webpack_public_path__ + "static/media/NoErrorOrWarning.b89e46f4.png";